import React, { useContext, useEffect, useState } from 'react';
import { GEtTAgWithVideoID } from '../../Services/allApi';
import { useParams } from 'react-router-dom';
import { addcontext } from '../../ContextShare/ContextShare';

function TagOfVideo() {
    const params = useParams();
    const videoIdFromUrl = params.vId;
    const [vIdToUrl, setVIdToUrl] = useState('');
    const [tags, setTags] = useState([]);    
    const { isPartClicked, setisPartClicked } = useContext(addcontext);
    const { newIdP, setnewIdP } = useContext(addcontext);
    
    // show tags of videos by mappingid
    const getTagsForVideo = async (dd) => {
        const res = await GEtTAgWithVideoID(dd);
        console.log(res?.data?.data);
        setTags(res?.data?.data || []);
    };

    useEffect(() => {
        const newId = videoIdFromUrl?.replace(/:/g, '');
        setVIdToUrl(newId);
        if (newId) {
            console.log(vIdToUrl);
            getTagsForVideo(newId);
        }
    }, [vIdToUrl, isPartClicked, newIdP]);

    return (
        <div className={`${tags.length ? 'flex flex-row flex-wrap w-full justify-center items-center p-4' : 'hidden'}`}>
            {tags?.map((tagEach, index) => (
                <div 
                    key={index} 
                    className='flex w-full sm:w-1/2 md:w-1/3 lg:w-1/6 m-2 p-1 rounded-lg border border-gray-300 bg-success shadow-md hover:shadow-lg transition-shadow text-xs'
                > 
                    <div className='w-1 h-8 rounded-l-lg' style={{ backgroundColor: '#001F33' }} ></div>
                    <div className='flex items-center justify-center h-8 px-4 bg-blue-gray-50 text-gray-900 border-r border-gray-300 truncate'>
                        {tagEach?.key}
                    </div>
                    <div title={tagEach?.value} className='flex-1 flex items-center justify-center h-8 px-6 bg-blue-gray-50 text-gray-900 rounded-r-lg border-l border-gray-300 overflow-x-scroll hide-scroll-bar truncate text-xs'>
                        {tagEach?.value}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TagOfVideo;
